


// /////////////////////////////////////////////////////// Update dash Board on user side 15 / 06 / 2025
// import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
// import { collection, getDocs, getDoc, doc, onSnapshot } from "firebase/firestore";
// import { db, auth } from "../firebase";
// import Swal from "sweetalert2";
// import "bootstrap/dist/css/bootstrap.min.css";
//  import {useNavigate } from 'react-router-dom';
// // import { Link, useNavigate } from 'react-router-dom';
// import { signOut } from 'firebase/auth';
// import "./Dashboard.css";

// const Dashboard = () => {
//   const [finesData, setFinesData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortField, setSortField] = useState("userName");
//   const [sortDirection, setSortDirection] = useState("asc");
//   const [selectedStatus, setSelectedStatus] = useState("all");
//   const [dateRange, setDateRange] = useState("all");
//   const [refreshing, setRefreshing] = useState(false);
//   const [expandedCards, setExpandedCards] = useState(new Set());
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
  
//   // Refs for cleanup and optimization
//   const unsubscribeRef = useRef(null);
//   const retryTimeoutRef = useRef(null);

//   // Constants for better maintainability
//   const DATE_RANGES = {
//     all: { label: "All Time", days: Infinity },
//     week: { label: "Last Week", days: 7 },
//     month: { label: "Last Month", days: 30 },
//     quarter: { label: "Last 3 Months", days: 90 }
//   };

//   const STATUS_OPTIONS = {
//     all: "All Status",
//     pending: "Has Pending",
//     paid: "Has Paid"
//   };

//   // Enhanced fetch function with real-time updates and better error handling
//   const setupRealtimeListener = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       // Clean up previous listener
//       if (unsubscribeRef.current) {
//         unsubscribeRef.current();
//       }

//       const finesCollection = collection(db, "Fines");
      
//       // Set up real-time listener
//       unsubscribeRef.current = onSnapshot(
//         finesCollection,
//         async (usersSnapshot) => {
//           if (usersSnapshot.empty) {
//             setFinesData([]);
//             setLoading(false);
//             return;
//           }

//           try {
//             // Process users in batches to avoid overwhelming the system
//             const batchSize = 10;
//             const userDocs = usersSnapshot.docs;
//             const allUserData = [];

//             for (let i = 0; i < userDocs.length; i += batchSize) {
//               const batch = userDocs.slice(i, i + batchSize);
              
//               const batchPromises = batch.map(async (userDoc) => {
//                 const userId = userDoc.id;
//                 const userData = userDoc.data();
//                 const totalFine = userData.TotalFine || 0;
//                 const pendingFine = userData.PendingFine || 0;
                
//                 try {
//                   const [userInfoDoc, finesSnapshot] = await Promise.all([
//                     getDoc(doc(db, "users", userId)),
//                     getDocs(collection(db, "Fines", userId, "fines"))
//                   ]);
                  
//                   const userName = userInfoDoc.exists()
//                     ? userInfoDoc.data().userName || "Unknown User"
//                     : "Unknown User";
                    
//                   const fines = finesSnapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     ...doc.data(),
//                     date: doc.data().date || new Date().toISOString().split('T')[0]
//                   })).sort((a, b) => new Date(b.date) - new Date(a.date));
                  
//                   return {
//                     userId,
//                     userName,
//                     fines,
//                     totalFine,
//                     pendingFine,
//                     lastActivity: fines.length > 0 ? fines[0].date : null,
//                     fineCount: fines.length
//                   };
//                 } catch (userError) {
//                   console.warn(`Error fetching data for user ${userId}:`, userError);
//                   return {
//                     userId,
//                     userName: "Error Loading User",
//                     fines: [],
//                     totalFine,
//                     pendingFine,
//                     lastActivity: null,
//                     fineCount: 0,
//                     hasError: true
//                   };
//                 }
//               });
              
//               const batchResults = await Promise.all(batchPromises);
//               allUserData.push(...batchResults);
//             }
            
//             setFinesData(allUserData.filter(user => user !== null));
//             setError(null);
//           } catch (processingError) {
//             console.error("Error processing fines data:", processingError);
//             setError("Failed to process fines data");
//           } finally {
//             setLoading(false);
//             setRefreshing(false);
//           }
//         },
//         (error) => {
//           console.error("Firestore listener error:", error);
//           setError("Connection lost. Attempting to reconnect...");
//           setLoading(false);
//           setRefreshing(false);
          
//           // Retry connection after 5 seconds
//           retryTimeoutRef.current = setTimeout(() => {
//             setupRealtimeListener();
//           }, 5000);
//         }
//       );
//     } catch (error) {
//       console.error("Error setting up listener:", error);
//       setError("Failed to connect to database");
//       setLoading(false);
//       setRefreshing(false);
//     }
//   }, []);

//   // Manual refresh function
//   const handleRefresh = useCallback(() => {
//     setRefreshing(true);
//     setupRealtimeListener();
//   }, [setupRealtimeListener]);

//   useEffect(() => {
//     setupRealtimeListener();
    
//     return () => {
//       if (unsubscribeRef.current) {
//         unsubscribeRef.current();
//       }
//       if (retryTimeoutRef.current) {
//         clearTimeout(retryTimeoutRef.current);
//       }
//     };
//   }, [setupRealtimeListener]);

//   const handleSort = useCallback((field) => {
//     if (sortField === field) {
//       setSortDirection(prev => prev === "asc" ? "desc" : "asc");
//     } else {
//       setSortField(field);
//       setSortDirection("asc");
//     }
//   }, [sortField]);

//   const toggleCardExpansion = useCallback((userId) => {
//     setExpandedCards(prev => {
//       const newSet = new Set(prev);
//       if (newSet.has(userId)) {
//         newSet.delete(userId);
//       } else {
//         newSet.add(userId);
//       }
//       return newSet;
//     });
//   }, []);

//   // Optimized filtering and sorting with better performance
//   const sortedAndFilteredData = useMemo(() => {
//     if (loading || !finesData.length) return [];

//     let filtered = finesData.filter(user => {
//       // Text search optimization
//       if (searchTerm) {
//         const searchLower = searchTerm.toLowerCase();
//         const matchesSearch = user.userName.toLowerCase().includes(searchLower) ||
//                              user.userId.toLowerCase().includes(searchLower);
//         if (!matchesSearch) return false;
//       }
      
//       // Status filter optimization
//       if (selectedStatus !== "all") {
//         const hasPendingFines = user.pendingFine > 0;
//         const hasPaidFines = user.totalFine > user.pendingFine;
        
//         if (selectedStatus === "pending" && !hasPendingFines) return false;
//         if (selectedStatus === "paid" && !hasPaidFines) return false;
//       }
      
//       // Date range filter optimization
//       if (dateRange !== "all" && user.lastActivity) {
//         const activityDate = new Date(user.lastActivity);
//         const now = new Date();
//         const daysDiff = (now - activityDate) / (1000 * 60 * 60 * 24);
        
//         if (daysDiff > DATE_RANGES[dateRange].days) return false;
//       }
      
//       return true;
//     });

//     // Optimized sorting
//     return filtered.sort((a, b) => {
//       let aValue, bValue;
      
//       switch (sortField) {
//         case "totalFine":
//         case "pendingFine":
//           aValue = a[sortField] || 0;
//           bValue = b[sortField] || 0;
//           return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
//         case "lastActivity":
//           aValue = a.lastActivity ? new Date(a.lastActivity) : new Date(0);
//           bValue = b.lastActivity ? new Date(b.lastActivity) : new Date(0);
//           return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
//         case "fineCount":
//           aValue = a.fineCount || 0;
//           bValue = b.fineCount || 0;
//           return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
//         default:
//           aValue = (a[sortField] || "").toString();
//           bValue = (b[sortField] || "").toString();
//           return sortDirection === "asc" 
//             ? aValue.localeCompare(bValue)
//             : bValue.localeCompare(aValue);
//       }
//     });
//   }, [finesData, sortField, sortDirection, searchTerm, selectedStatus, dateRange, loading]);

//   // Enhanced summary calculations with more metrics
//   const summaryData = useMemo(() => {
//     if (!finesData.length) {
//       return {
//         totalAllFines: 0,
//         totalPendingFines: 0,
//         totalPaidFines: 0,
//         percentPending: 0,
//         collectionRate: 0,
//         usersWithPendingFines: 0,
//         averageFinePerUser: 0,
//         totalFineCount: 0,
//         recentActivity: 0
//       };
//     }

//     const totalAllFines = finesData.reduce((sum, user) => sum + (user.totalFine || 0), 0);
//     const totalPendingFines = finesData.reduce((sum, user) => sum + (user.pendingFine || 0), 0);
//     const totalPaidFines = totalAllFines - totalPendingFines;
//     const percentPending = totalAllFines ? Math.round((totalPendingFines / totalAllFines) * 100) : 0;
//     const collectionRate = 100 - percentPending;
//     const usersWithPendingFines = finesData.filter(user => user.pendingFine > 0).length;
//     const averageFinePerUser = Math.round(totalAllFines / finesData.length);
//     const totalFineCount = finesData.reduce((sum, user) => sum + user.fineCount, 0);
    
//     // Recent activity (last 7 days)
//     const weekAgo = new Date();
//     weekAgo.setDate(weekAgo.getDate() - 7);
//     const recentActivity = finesData.filter(user => 
//       user.lastActivity && new Date(user.lastActivity) >= weekAgo
//     ).length;
    
//     return {
//       totalAllFines,
//       totalPendingFines,
//       totalPaidFines,
//       percentPending,
//       collectionRate,
//       usersWithPendingFines,
//       averageFinePerUser,
//       totalFineCount,
//       recentActivity
//     };
//   }, [finesData]);
  
//   // Optimized formatting functions
//   const formatCurrency = useCallback((amount) => {
//     return new Intl.NumberFormat("en-PK", {
//       style: "currency",
//       currency: "PKR",
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     }).format(amount || 0);
//   }, []);

//   const formatDate = useCallback((dateString) => {
//     if (!dateString) return "N/A";
//     try {
//       return new Date(dateString).toLocaleDateString('en-PK', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric'
//       });
//     } catch {
//       return dateString;
//     }
//   }, []);

//   const handleLogout = useCallback(async () => {
//     const result = await Swal.fire({
//       title: 'Confirm Logout',
//       text: 'Are you sure you want to logout?',
//       icon: 'question',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, logout'
//     });

//     if (result.isConfirmed) {
//       try {
//         // Cleanup listeners before logout
//         if (unsubscribeRef.current) {
//           unsubscribeRef.current();
//         }
//         await signOut(auth);
//         navigate('/login');
//       } catch (error) {
//         console.error("Logout error:", error);
//         Swal.fire({
//           icon: 'error',
//           title: 'Logout Failed',
//           text: 'Please try again'
//         });
//       }
//     }
//   }, [navigate]);

//   const clearAllFilters = useCallback(() => {
//     setSearchTerm("");
//     setSelectedStatus("all");
//     setDateRange("all");
//     setSortField("userName");
//     setSortDirection("asc");
//   }, []);

//   // Error handling component
//   const ErrorBanner = () => error && (
//     <div className="alert alert-warning alert-dismissible fade show mb-4" role="alert">
//       <i className="bi bi-exclamation-triangle me-2"></i>
//       {error}
//       <button 
//         type="button" 
//         className="btn-close" 
//         onClick={() => setError(null)}
//         aria-label="Close"
//       ></button>
//     </div>
//   );

//   return (
//     <div className="container-fluid py-4 px-2 px-sm-3 px-md-4 min-vh-100 gradient-background">
//       <ErrorBanner />
      
//       {/* Header Section */}
//       <div className="row mb-4">
//         <div className="col-12">
//           <div className="card shadow-sm border-0 rounded-3 glass-card">
//             <div className="card-body">
//               <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-4 gap-3">
//                 <div>
//                   <h2 className="h3 mb-1 text-primary fw-bold">
//                     <i className="bi bi-cash-coin me-2"></i>
//                     Fines Management Dashboard
//                   </h2>
//                   <p className="text-muted mb-0">
//                     <i className="bi bi-broadcast me-1"></i>
//                     Real-time updates • Last synced: {new Date().toLocaleString('en-PK')}
//                     {refreshing && (
//                       <span className="ms-2">
//                         <i className="bi bi-arrow-clockwise spinner-grow spinner-grow-sm text-primary"></i>
//                         Refreshing...
//                       </span>
//                     )}
//                   </p>
//                 </div>

//                 <div className="d-flex flex-wrap gap-2">
//                   <button
//                     onClick={handleRefresh}
//                     className="btn btn-outline-primary"
//                     disabled={refreshing}
//                     title="Manual refresh"
//                   >
//                     <i className={`bi bi-arrow-clockwise ${refreshing ? 'fa-spin' : ''}`}></i>
//                     Refresh
//                   </button>
//                   {/* <Link to="/fines" className="btn btn-success">
//                     <i className="bi bi-plus-circle me-1"></i>
//                     Add Fine
//                   </Link>
//                   <Link to="/user" className="btn btn-warning">
//                     <i className="bi bi-people me-1"></i>
//                     Users
//                   </Link> */}
//                   <button onClick={handleLogout} className="btn btn-outline-secondary">
//                     <i className="bi bi-box-arrow-right me-1"></i>
//                     Logout
//                   </button>
//                 </div>
//               </div>

//               {/* Enhanced Filters */}
//               <div className="row g-3 mb-4">
//                 <div className="col-12 col-md-4">
//                   <div className="position-relative">
//                     <i className="bi bi-search position-absolute ms-3" style={{
//                       zIndex: 5,
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                     }}></i>
//                     <input
//                       type="text"
//                       className="form-control ps-5 rounded-pill border-0 shadow-sm"
//                       placeholder="Search users or ID..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                 </div>
                
//                 <div className="col-12 col-md-3">
//                   <select
//                     className="form-select rounded-pill border-0 shadow-sm"
//                     value={selectedStatus}
//                     onChange={(e) => setSelectedStatus(e.target.value)}
//                   >
//                     {Object.entries(STATUS_OPTIONS).map(([key, label]) => (
//                       <option key={key} value={key}>{label}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="col-12 col-md-3">
//                   <select
//                     className="form-select rounded-pill border-0 shadow-sm"
//                     value={dateRange}
//                     onChange={(e) => setDateRange(e.target.value)}
//                   >
//                     {Object.entries(DATE_RANGES).map(([key, config]) => (
//                       <option key={key} value={key}>{config.label}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="col-12 col-md-2">
//                   <button
//                     onClick={clearAllFilters}
//                     className="btn btn-outline-secondary w-100 rounded-pill"
//                     disabled={searchTerm === "" && selectedStatus === "all" && dateRange === "all"}
//                   >
//                     <i className="bi bi-x-circle me-1"></i>
//                     Clear
//                   </button>
//                 </div>
//               </div>

//               {/* Enhanced Summary Cards */}
//               <div className="row g-4 mb-2">
//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-white border-0 shadow-sm rounded-4 h-100 overflow-hidden glass-card transition-card">
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-primary bg-opacity-10 text-primary me-3">
//                           <i className="bi bi-cash-stack"></i>
//                         </div>
//                         <h6 className="fw-bold text-primary mb-0">Total Fines</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-2">
//                         {formatCurrency(summaryData.totalAllFines)}
//                       </h3>
//                       <div className="d-flex justify-content-between small text-muted">
//                         <span>{summaryData.totalFineCount} total fines</span>
//                         <span>Avg: {formatCurrency(summaryData.averageFinePerUser)}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-white border-0 shadow-sm rounded-4 h-100 overflow-hidden glass-card transition-card">
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-warning bg-opacity-10 text-warning me-3">
//                           <i className="bi bi-hourglass-split"></i>
//                         </div>
//                         <h6 className="fw-bold text-warning mb-0">Pending Fines</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-2">
//                         {formatCurrency(summaryData.totalPendingFines)}
//                       </h3>
//                       <div className="d-flex justify-content-between small text-muted">
//                         <span>{summaryData.percentPending}% of total</span>
//                         <span>{summaryData.usersWithPendingFines} users</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-white border-0 shadow-sm rounded-4 h-100 overflow-hidden glass-card transition-card">
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-success bg-opacity-10 text-success me-3">
//                           <i className="bi bi-check-circle"></i>
//                         </div>
//                         <h6 className="fw-bold text-success mb-0">Collected</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-2">
//                         {formatCurrency(summaryData.totalPaidFines)}
//                       </h3>
//                       <div className="d-flex justify-content-between small text-muted">
//                         <span>{summaryData.collectionRate}% rate</span>
//                         <span>Successfully paid</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 col-sm-6 col-lg-3">
//                   <div className="card bg-white border-0 shadow-sm rounded-4 h-100 overflow-hidden glass-card transition-card">
//                     <div className="card-body position-relative p-4">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="icon-circle bg-info bg-opacity-10 text-info me-3">
//                           <i className="bi bi-people"></i>
//                         </div>
//                         <h6 className="fw-bold text-info mb-0">Active Users</h6>
//                       </div>
//                       <h3 className="display-6 fw-bold mb-2">
//                         {finesData.length}
//                       </h3>
//                       <div className="d-flex justify-content-between small text-muted">
//                         <span>{summaryData.recentActivity} this week</span>
//                         <span>{sortedAndFilteredData.length} shown</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Results Section */}
//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-grow text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="mt-3 text-muted">Loading fines data...</p>
//         </div>
//       ) : sortedAndFilteredData.length === 0 ? (
//         <div className="card shadow-sm border-0 rounded-3 p-4 text-center glass-card">
//           <div className="py-4">
//             <i className="bi bi-search text-muted" style={{ fontSize: "3rem" }}></i>
//             <h4 className="mt-3">No Results Found</h4>
//             <p className="text-muted mb-3">
//               {finesData.length === 0 
//                 ? "No users with fines found in the system."
//                 : "No users found matching your current filters."
//               }
//             </p>
//             {(searchTerm || selectedStatus !== "all" || dateRange !== "all") && (
//               <button className="btn btn-outline-primary" onClick={clearAllFilters}>
//                 <i className="bi bi-arrow-clockwise me-1"></i>
//                 Clear All Filters
//               </button>
//             )}
//           </div>
//         </div>
//       ) : (
//         <>
//           {/* Results Header */}
//           <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-3 gap-2">
//             <h5 className="mb-0">
//               Showing {sortedAndFilteredData.length} of {finesData.length} users
//             </h5>
//             <div className="d-flex flex-wrap gap-2">
//               <div className="btn-group btn-group-sm">
//                 {[
//                   { key: 'userName', label: 'Name', icon: 'person' },
//                   { key: 'totalFine', label: 'Total', icon: 'currency-dollar' },
//                   { key: 'fineCount', label: 'Count', icon: 'hash' },
//                   { key: 'lastActivity', label: 'Recent', icon: 'clock' }
//                 ].map(({ key, label, icon }) => (
//                   <button
//                     key={key}
//                     className={`btn ${sortField === key ? 'btn-primary' : 'btn-outline-primary'}`}
//                     onClick={() => handleSort(key)}
//                     title={`Sort by ${label}`}
//                   >
//                     <i className={`bi bi-${icon} me-1`}></i>
//                     {label} {sortField === key && <i className={`bi bi-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`}></i>}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* User Cards */}
//           <div className="row g-4">
//             {sortedAndFilteredData.map((user) => {
//               const isExpanded = expandedCards.has(user.userId);
//               const displayedFines = isExpanded ? user.fines : user.fines.slice(0, 3);
              
//               return (
//                 <div key={user.userId} className="col-12 col-lg-6">
//                   <div className={`card shadow-sm border-0 rounded-3 overflow-hidden h-100 transition-card glass-card ${
//                     user.hasError ? 'border-danger border-opacity-25' : ''
//                   }`}>
//                     <div className={`card-header py-3 ${
//                       user.hasError
//                         ? 'bg-danger bg-opacity-10 border-bottom border-danger'
//                         : user.pendingFine > 0 
//                           ? 'bg-warning bg-opacity-10 border-bottom border-warning' 
//                           : 'bg-primary bg-opacity-10 border-bottom border-primary'
//                     }`}>
//                       <div className="d-flex justify-content-between align-items-center">
//                         <div className="flex-grow-1">
//                           <h5 className={`mb-1 fw-bold ${
//                             user.hasError ? 'text-danger' :
//                             user.pendingFine > 0 ? 'text-warning' : 'text-primary'
//                           }`}>
//                             <i className="bi bi-person-circle me-2"></i>
//                             {user.userName}
//                             {user.hasError && <i className="bi bi-exclamation-triangle ms-2"></i>}
//                           </h5>
//                           <div className="d-flex flex-wrap gap-3 small text-muted">
//                             {/* <span>
//                               <i className="bi bi-hash me-1"></i>
//                               {user.userId.substring(0, 8)}...
//                             </span> */}
//                             <span>
//                               <i className="bi bi-list-ol me-1"></i>
//                               {user.fineCount} fines
//                             </span>
//                             {user.lastActivity && (
//                               <span>
//                                 <i className="bi bi-clock me-1"></i>
//                                 {formatDate(user.lastActivity)}
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                         <div className="text-end">
//                           <h6 className={`mb-1 fw-bold ${
//                             user.hasError ? 'text-danger' :
//                             user.pendingFine > 0 ? 'text-warning' : 'text-primary'
//                           }`}>
//                             {formatCurrency(user.totalFine)}
//                           </h6>
//                           <div className="small">
//                             {user.hasError ? (
//                               <span className="badge bg-danger text-white rounded-pill px-3 py-1">
//                                 <i className="bi bi-exclamation-triangle me-1"></i>
//                                 Error loading
//                               </span>
//                             ) : user.pendingFine > 0 ? (
//                               <span className="badge bg-warning text-dark rounded-pill px-3 py-1">
//                                 <i className="bi bi-exclamation-triangle me-1"></i>
//                                 {formatCurrency(user.pendingFine)} pending
//                               </span>
//                             ) : (
//                               <span className="badge bg-success text-white rounded-pill px-3 py-1">
//                                 <i className="bi bi-check-circle me-1"></i>
//                                 All paid
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="card-body p-0">
//                       <div className="table-container" style={{ 
//                         maxHeight: isExpanded ? '400px' : '300px', 
//                         overflowY: 'auto'
//                       }}>
//                         <table className="table table-hover align-middle mb-0 sticky-header">
//                           <thead className="bg-light sticky-top">
//                             <tr>
//                               <th className="px-3">Fine Reason</th>
//                               <th>Amount</th>
//                               <th>Date</th>
//                               <th>Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {user.fines.length > 0 ? (
//                               displayedFines.map((fine, index) => (
//                                 <tr key={fine.id || index}>
//                                   <td className="px-3 text-wrap" style={{ 
//                                     maxWidth: '200px', 
//                                     wordWrap: 'break-word', 
//                                     whiteSpace: 'normal' 
//                                   }}>
//                                     <div className="fw-medium">{fine.fineType}</div>
//                                     {fine.description && (
//                                       <small className="text-muted">{fine.description}</small>
//                                     )}
//                                   </td>
//                                   <td className="fw-medium text-primary">
//                                     {formatCurrency(fine.amount)}
//                                   </td>
//                                   <td className="text-muted small">
//                                     {formatDate(fine.date)}
//                                   </td>
//                                   <td>
//                                     <span className={`badge ${
//                                       fine.status === "Paid"
//                                         ? "bg-success"
//                                         : "bg-warning text-dark"
//                                     } rounded-pill px-3 py-2`}>
//                                       {fine.status === "Paid" ? (
//                                         <>
//                                           <i className="bi bi-check-circle me-1"></i>
//                                           Paid
//                                         </>
//                                       ) : (
//                                         <>
//                                           <i className="bi bi-clock me-1"></i>
//                                           Pending
//                                         </>
//                                       )}
//                                     </span>
//                                   </td>
//                                 </tr>
//                               ))
//                             ) : (
//                               <tr>
//                                 <td colSpan="4" className="text-center py-4 text-muted">
//                                   <i className="bi bi-inbox me-2"></i>
//                                   No fines recorded for this user
//                                 </td>
//                               </tr>
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
                      
//                       {user.fines.length > 3 && (
//                         <div className="card-footer bg-light border-0">
//                           <button
//                             className="btn btn-sm btn-outline-primary w-100"
//                             onClick={() => toggleCardExpansion(user.userId)}
//                           >
//                             <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'} me-1`}></i>
//                             {isExpanded 
//                               ? 'Show Less' 
//                               : `Show All ${user.fines.length} Fines`
//                             }
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Dashboard;




import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { collection, getDocs, getDoc, doc, onSnapshot } from "firebase/firestore";
import { db, auth } from "../firebase";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import "../styles/userDashBoard.css";

// ── Helpers ───────────────────────────────────────────────────────────────────
const fmt = (n) =>
  new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR", minimumFractionDigits: 0 }).format(n || 0);

const fmtDate = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-PK", { year: "numeric", month: "short", day: "numeric" });
};

// ── Stat Card Themes ──────────────────────────────────────────────────────────
const THEMES = {
  blue:   { bg: "linear-gradient(135deg,#6366f1,#818cf8)", shadow: "0 8px 24px rgba(99,102,241,.3)" },
  amber:  { bg: "linear-gradient(135deg,#f59e0b,#fbbf24)", shadow: "0 8px 24px rgba(245,158,11,.3)" },
  green:  { bg: "linear-gradient(135deg,#10b981,#34d399)", shadow: "0 8px 24px rgba(16,185,129,.3)" },
  purple: { bg: "linear-gradient(135deg,#8b5cf6,#a78bfa)", shadow: "0 8px 24px rgba(139,92,246,.3)" },
  rose:   { bg: "linear-gradient(135deg,#ef4444,#f87171)", shadow: "0 8px 24px rgba(239,68,68,.3)" },
};

// ── Stat Card ─────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, sub, accent, icon }) => {
const t = THEMES[accent];
  return (
    <div className="stat-card" style={{ background: t.bg, boxShadow: t.shadow }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span className="stat-card__label">{label}</span>
        <span className="stat-card__icon">{icon}</span>
      </div>
      <div className="stat-card__value">{value}</div>
      <div className="stat-card__sub">{sub}</div>
    </div>
  );
};

// ── User Card ─────────────────────────────────────────────────────────────────
const UserCard = ({ user }) => {
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? user.fines : user.fines.slice(0, 3);
  const hasPending = user.pendingFine > 0;

  return (
    <div className="user-card">
      {/* Header */}
      <div className={`user-card__header ${hasPending ? "user-card__header--pending" : "user-card__header--cleared"}`}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className={`user-card__name ${hasPending ? "user-card__name--pending" : "user-card__name--cleared"}`}>
            <span>👤</span>
            <span>{user.userName}</span>
          </div>
          <div className="user-card__meta">
            {user.fineCount} fines · Last: {fmtDate(user.lastActivity)}
            <span className={user.userStatus === "Inactive" ? "b-user-inactive" : "b-user-Active"}>
              {user.userStatus === "Inactive" ? "● Inactive" : "● Active"}
            </span>
          </div>
        </div>
        <div style={{ flexShrink: 0 }}>
          <div className="user-card__total">{fmt(user.totalFine)}</div>
          {hasPending
            ? <span className="b-due">⏳ {fmt(user.pendingFine)} due</span>
            : <span className="b-clear">✓ Cleared</span>
          }
        </div>
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table className="fine-table">
          <thead>
            <tr>
              <th>Reason</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {shown.length > 0 ? shown.map((f, i) => (
              <tr key={f.id || i}>
                <td>
                  <div className="fine-table__reason">{f.fineType}</div>
                  {f.description && <div className="fine-table__desc">{f.description}</div>}
                </td>
                <td className="fine-table__amount">{fmt(f.amount)}</td>
                <td className="fine-table__date">{fmtDate(f.date)}</td>
                <td>
                  {f.status === "Paid"
                    ? <span className="b-paid">✓ Paid</span>
                    : <span className="b-pend">⏳ Pending</span>
                  }
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={4} className="fine-table__empty">No fines recorded</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Expand */}
      {user.fines.length > 3 && (
        <button className="btn-expand" onClick={() => setExpanded(e => !e)}>
          {expanded ? "▲ Show Less" : `▼ Show All ${user.fines.length} Fines`}
        </button>
      )}
    </div>
  );
};

// ── Main Dashboard ────────────────────────────────────────────────────────────
const Dashboard = () => {
  const [data, setData]             = useState([]);
  const [loading, setLoading]       = useState(true);
  const [search, setSearch]         = useState("");
  const [status, setStatus]         = useState("all");
  const [sort, setSort]             = useState({ field: "userName", dir: "asc" });
  const [error, setError]           = useState(null);
  const [usedAmount, setUsedAmount] = useState(0);
  const unsubRef = useRef(null);
  const navigate = useNavigate();

  // Real-time fines listener
  const init = useCallback(async () => {
    setLoading(true);
    if (unsubRef.current) unsubRef.current();

    unsubRef.current = onSnapshot(collection(db, "Fines"), async (snap) => {
      if (snap.empty) { setData([]); setLoading(false); return; }

      const results = await Promise.all(snap.docs.map(async (d) => {
        const uid = d.id;
        const { TotalFine = 0, PendingFine = 0 } = d.data();
        try {
          const [userDoc, finesSnap] = await Promise.all([
            getDoc(doc(db, "users", uid)),
            getDocs(collection(db, "Fines", uid, "fines"))
          ]);
          const fines = finesSnap.docs
            .map(f => ({ id: f.id, ...f.data(), date: f.data().date || "" }))
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          const uData = userDoc.exists() ? userDoc.data() : {};
          return {
            userId: uid,
            userName: uData.userName || "Unknown",
            userStatus: uData.status || "Active",
            fines, totalFine: TotalFine, pendingFine: PendingFine,
            fineCount: fines.length, lastActivity: fines[0]?.date || null
          };
        } catch {
          return { userId: uid, userName: "Error", userStatus: "Active", fines: [], totalFine: TotalFine, pendingFine: PendingFine, fineCount: 0, lastActivity: null };
        }
      }));

      setData(results);
      setLoading(false);
    }, () => {
      setError("Connection error. Retrying...");
      setLoading(false);
      setTimeout(init, 5000);
    });
  }, []);

  useEffect(() => { init(); return () => unsubRef.current?.(); }, [init]);

  // Fetch fines used on events
  useEffect(() => {
    const fetchUsedAmount = async () => {
      try {
        const snap = await getDoc(doc(db, "fineAmountHistory", "latest"));
        setUsedAmount(snap.exists() ? snap.data().usedAmount || 0 : 0);
      } catch (e) {
        console.error("Error fetching usedAmount:", e);
      }
    };
    fetchUsedAmount();
  }, []);

  // Summary stats
  const stats = useMemo(() => {
    const total   = data.reduce((s, u) => s + u.totalFine, 0);
    const pending = data.reduce((s, u) => s + u.pendingFine, 0);
    return {
      total, pending,
      collected: total - pending,
      users: data.length,
      pendingUsers: data.filter(u => u.pendingFine > 0).length,
      rate: total ? Math.round(((total - pending) / total) * 100) : 0
    };
  }, [data]);

  // Filter + sort
  const filtered = useMemo(() => {
    return data
      .filter(u => {
        if (search && !u.userName.toLowerCase().includes(search.toLowerCase())) return false;
        if (status === "pending" && u.pendingFine <= 0) return false;
        if (status === "paid"    && u.pendingFine >  0) return false;
        return true;
      })
      .sort((a, b) => {
        const mod = sort.dir === "asc" ? 1 : -1;
        if (["totalFine", "pendingFine", "fineCount"].includes(sort.field))
          return ((a[sort.field] || 0) - (b[sort.field] || 0)) * mod;
        return (a[sort.field] || "").toString().localeCompare((b[sort.field] || "").toString()) * mod;
      });
  }, [data, search, status, sort]);

  const toggleSort = (field) =>
    setSort(s => ({ field, dir: s.field === field && s.dir === "asc" ? "desc" : "asc" }));

  const logout = async () => {
    const r = await Swal.fire({ title: "Logout?", icon: "question", showCancelButton: true, confirmButtonText: "Yes" });
    if (r.isConfirmed) { unsubRef.current?.(); await signOut(auth); navigate("/login"); }
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="dash">

      {/* Header */}
      <div className="header-row">
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: "#1e293b", letterSpacing: -0.5, marginBottom: 4 }}>
            💰 Fines Dashboard
          </h1>
          <p style={{ color: "#94a3b8", fontSize: 13 }}>
            🟢 Live · {new Date().toLocaleString("en-PK")}
          </p>
        </div>
        <button className="btn-logout" onClick={logout}>Sign Out →</button>
      </div>

      {/* Error */}
      {error && (
        <div className="error-banner">
          <span>⚠ {error}</span>
          <button onClick={() => setError(null)}>✕</button>
        </div>
      )}

      {/* Stats */}
      <div className="stats-row">
        <StatCard label="Total Fines"   value={fmt(stats.total)}     sub={`${stats.users} total users`}      accent="blue"   icon="💳" />
        <StatCard label="Pending"       value={fmt(stats.pending)}   sub={`${stats.pendingUsers} users owe`} accent="amber"  icon="⏳" />
        <StatCard label="Collected"     value={fmt(stats.collected)} sub={`${stats.rate}% rate`}             accent="green"  icon="✅" />
        <StatCard label="Users"         value={stats.users}          sub={`${filtered.length} shown`}        accent="purple" icon="👥" />
        <StatCard label="Used on Event" value={fmt(usedAmount)}      sub="Allocated for events"              accent="rose"   icon="🎯" />
      </div>

      {/* Filters */}
      <div className="filters-row">
        <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
          <span style={{ position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", fontSize: 14 }}>🔍</span>
          <input
            className="inp"
            style={{ paddingLeft: 38, width: "100%" }}
            placeholder="Search users..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <select className="inp" value={status} onChange={e => setStatus(e.target.value)} style={{ cursor: "pointer", minWidth: 140 }}>
          <option value="all">All Status</option>
          <option value="pending">Has Pending</option>
          <option value="paid">All Paid</option>
        </select>
        <div className="sort-btns">
          {[["userName","Name"], ["totalFine","Total"], ["fineCount","Count"]].map(([f, l]) => (
            <button
              key={f}
              className={`btn-sort${sort.field === f ? " active" : ""}`}
              onClick={() => toggleSort(f)}
            >
              {l} {sort.field === f ? (sort.dir === "asc" ? "↑" : "↓") : ""}
            </button>
          ))}
        </div>
        {(search || status !== "all") && (
          <button className="btn-sort" onClick={() => { setSearch(""); setStatus("all"); }}>✕ Clear</button>
        )}
      </div>

      <p style={{ color: "#94a3b8", fontSize: 13, margin: "12px 0 20px" }}>
        Showing <strong style={{ color: "#6366f1" }}>{filtered.length}</strong> of {data.length} users
      </p>

      {/* Content */}
      {loading ? (
        <div className="empty-state">
          <div className="spin">⟳</div>
          <p style={{ marginTop: 16, fontSize: 15 }}>Loading fines data...</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state__icon">🔍</div>
          <p className="empty-state__text">No results found</p>
          {(search || status !== "all") && (
            <button className="btn-sort" style={{ marginTop: 16 }} onClick={() => { setSearch(""); setStatus("all"); }}>
              Clear Filters
            </button>
          )}
        </div>
      ) : (
        <div className="cards-grid">
          {filtered.map(user => <UserCard key={user.userId} user={user} />)}
        </div>
      )}

    </div>
  );
};

export default Dashboard;